import React, { useEffect, useState } from "react";
import { db, auth } from "../../firebase";
import { collection, query, where, getDocs, doc, updateDoc } from "firebase/firestore";
import { Spinner, Table, Badge, Button, Modal, Form, Row, Col, Image } from "react-bootstrap";
import Swal from "sweetalert2";

const StatusPendaftaran = () => {
  const [pendaftaranList, setPendaftaranList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [formData, setFormData] = useState({});
  const [fileUpdates, setFileUpdates] = useState({});
  const [updating, setUpdating] = useState(false);

  // Load data
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (!user) {
        setPendaftaranList([]);
        setLoading(false);
        return;
      }

      try {
        const ppdbRef = collection(db, "ppdb");
        const q = query(ppdbRef, where("uid", "==", user.uid));
        const querySnap = await getDocs(q);

        const list = querySnap.docs.map(docSnap => ({ id: docSnap.id, ...docSnap.data() }));
        // Urutkan terbaru
        list.sort((a, b) => {
          const tA = a.tanggal_daftar?.toDate ? a.tanggal_daftar.toDate().getTime() : new Date(a.tanggal_daftar).getTime();
          const tB = b.tanggal_daftar?.toDate ? b.tanggal_daftar.toDate().getTime() : new Date(b.tanggal_daftar).getTime();
          return tB - tA;
        });

        setPendaftaranList(list);
      } catch (err) {
        console.error(err);
        Swal.fire("Error", "Gagal memuat data pendaftaran", "error");
      } finally {
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, []);

  const openModal = (item, isEdit = false) => {
    setSelectedDoc({ ...item, isEdit });
    setFormData({ ...item });
    setFileUpdates({});
    setShowModal(true);
  };

  const handleInputChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (!files || files.length === 0) return;

    const file = files[0];
    setFileUpdates({ ...fileUpdates, [name]: file });

    const reader = new FileReader();
    reader.onload = () => {
      setFormData({ ...formData, [name]: reader.result });
    };
    reader.readAsDataURL(file);
  };

  const handleUpdate = async () => {
    if (!selectedDoc) return;

    Swal.fire({
      title: "Yakin ingin menyimpan perubahan?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Ya, simpan",
      cancelButtonText: "Batal"
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      setUpdating(true);

      try {
        const docRef = doc(db, "ppdb", selectedDoc.id);

        // Simpan semua formData + base64
        await updateDoc(docRef, { ...formData });

        setShowModal(false);
        Swal.fire("Berhasil", "Data berhasil diperbarui!", "success");
        // Refresh data
        const updatedList = pendaftaranList.map(item => item.id === selectedDoc.id ? { ...formData } : item);
        setPendaftaranList(updatedList);
      } catch (err) {
        console.error(err);
        Swal.fire("Error", "Gagal memperbarui data.", "error");
      } finally {
        setUpdating(false);
      }
    });
  };

  if (loading) return (
    <div className="text-center mt-5">
      <Spinner animation="border" />
      <p className="mt-2">Memuat riwayat pendaftaran...</p>
    </div>
  );

  return (
    <div className="container mt-5">
      <h3 className="mb-4">Status & Riwayat Pendaftaran</h3>

      {pendaftaranList.length === 0 ? (
        <p>Anda belum mendaftar PPDB.</p>
      ) : (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>No</th>
              <th>Tanggal Daftar</th>
              <th>Status</th>
              <th>Aksi</th>
            </tr>
          </thead>
          <tbody>
            {pendaftaranList.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{item.tanggal_daftar?.toDate ? item.tanggal_daftar.toDate().toLocaleString() : new Date(item.tanggal_daftar).toLocaleString()}</td>
                <td>
                  <Badge bg={
                    item.status === "Diterima" ? "success" :
                    item.status === "Ditolak" ? "danger" :
                    "secondary"
                  }>
                    {item.status || "Menunggu"}
                  </Badge>
                </td>
                <td>
                  <Button size="sm" variant="info" onClick={() => openModal(item, false)}>Lihat Data</Button>
                  {item.status === "Menunggu" && (
                    <Button size="sm" variant="warning" className="ms-2" onClick={() => openModal(item, true)}>Ubah Data</Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      {/* Modal Preview/Edit */}
{/* Modal Preview/Edit */}
{/* Modal Preview/Edit */}
<Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
  <Modal.Header closeButton>
    <Modal.Title>{selectedDoc?.isEdit ? "Edit Data" : "Preview Data"}</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <Row>
      <Col md={6}>
        {[
          "nama",
          "nisn",
          "tempat_lahir",
          "tanggal_lahir",
          "jenis_kelamin",
          "asal_sekolah",
          "alamat",
          "telepon",
          "nilai_rata",
          "nama_ayah",
          "nama_ibu",
          "pekerjaan_ayah",
          "pekerjaan_ibu",
          "pendidikan_ayah",
          "pendidikan_ibu"
        ].map(field => (
          <Form.Group className="mb-2" key={field}>
            <Form.Label>{field.replace("_", " ").toUpperCase()}</Form.Label>

            {selectedDoc?.isEdit ? (
              <Form.Control
                type={field === "tanggal_lahir" ? "date" : "text"}
                name={field}
                value={formData[field] || ""}
                onChange={handleInputChange}
              />
            ) : (
              <p>{formData[field] || "-"}</p>
            )}
          </Form.Group>
        ))}
      </Col>

      <Col md={6}>
        {[
          { key: "pasFoto", label: "Pas Foto" },
          { key: "fotoKK", label: "Kartu Keluarga" },
          { key: "fotoRapor", label: "Rapor" },
          { key: "ijazah", label: "Ijazah" },
          { key: "piagam", label: "Piagam (Opsional)" }
        ].map(file => (
          <Form.Group className="mb-3" key={file.key}>
            <Form.Label>{file.label}</Form.Label>

            {/* PREVIEW */}
            {formData[file.key] ? (
              formData[file.key].includes(".pdf") ? (
                <Button
                  variant="primary"
                  size="sm"
                  onClick={() => window.open(formData[file.key], "_blank")}
                >
                  Lihat PDF
                </Button>
              ) : (
                <Image
                  src={formData[file.key]}
                  width={140}
                  rounded
                  className="d-block mb-2"
                />
              )
            ) : (
              <p>-</p>
            )}

            {/* INPUT FILE SAAT EDIT */}
            {selectedDoc?.isEdit && (
              <Form.Control
                type="file"
                accept="image/*,application/pdf"
                name={file.key}
                onChange={handleFileChange}
              />
            )}
          </Form.Group>
        ))}
      </Col>
    </Row>
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowModal(false)}>Tutup</Button>

    {selectedDoc?.isEdit && (
      <Button variant="primary" onClick={handleUpdate} disabled={updating}>
        {updating ? "Menyimpan..." : "Simpan"}
      </Button>
    )}
  </Modal.Footer>
</Modal>

    </div>
  );
};

export default StatusPendaftaran;
